import { GeneralMap } from 'src/components/GeneralMap';

export const MapPage = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen text-center p-8">
      <GeneralMap className="w-full h-full" />
    </div>
  );
};
